<ol>
    @for (row of rows(); track row.id) {
        <li>
            <span class="rank">{{ $index + 1 }}</span>
            <span class="name">{{ row.name || '—' }}</span>
            <div class="track">
                <div class="fill" [style.width.%]="(row.count / max()) * 100" [clTooltip]="row.label"></div>
            </div>
            <span class="count">{{ row.count | number }}</span>
            @if (total(); as total) {
                <span class="share">{{ row.count / total | percent: '1.0-1' }}</span>
            }
        </li>
    }
</ol>
